/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.1
 */

import { RefObject } from 'react';

import get from 'lodash/get';
import invoke from 'lodash/invoke';
import Carousel from 'react-multi-carousel';

import { icons } from '../../../../../../assets';
import { ChartArrowLeftStyled, ChartArrowRightStyled } from '../styled/WidgetChartStyled';
import { WidgetCostsArrowContainerStyled } from '../styled/WidgetCostsStyled';

export interface IWidgetCostsChartArrowProps {
    carouselRef: RefObject<Carousel>;
    isLeftDisabled?: boolean;
    isRightDisabled?: boolean;
    onArrowLeftClick: () => void;
    onArrowRightClick: () => void;
}

const WidgetCostsSliderArrow = (props: IWidgetCostsChartArrowProps) => {

    const { carouselRef, isLeftDisabled, isRightDisabled } = props;

    const onRightArrowClick = () => {
        if (!isRightDisabled) {
            const nextSlide = get(carouselRef, 'current.state.currentSlide', 1) + 1;
            invoke(carouselRef, 'current.next', 1);
            invoke(carouselRef, 'current.goToSlide', nextSlide);
            props.onArrowRightClick();
        }
    };

    const onLeftArrowClick = () => {
        if (!isLeftDisabled) {
            const prevSlide = get(carouselRef, 'current.state.currentSlide', 1) - 1;
            invoke(carouselRef, 'current.previous', 1);
            invoke(carouselRef, 'current.goToSlide', prevSlide);
            props.onArrowLeftClick();
        }
    };

    return (
        <WidgetCostsArrowContainerStyled>
            <ChartArrowLeftStyled
                className={isLeftDisabled ? 'disabled' : ''}
                data-chart-arrow="leftArrow"
                src={isLeftDisabled ? icons.arrowLeftDisabledIcon : icons.arrowLeftIcon}
                onClick={onLeftArrowClick}
            />
            <ChartArrowRightStyled
                className={isRightDisabled ? 'disabled' : ''}
                data-chart-arrow="rightArrow"
                src={isRightDisabled ? icons.arrowRightDisabledIcon : icons.arrowRightIcon}
                onClick={onRightArrowClick}
            />
        </WidgetCostsArrowContainerStyled>
    );
};

export default WidgetCostsSliderArrow;
